import { useCallback } from 'react';

import { getHashCode } from '@atlaskit/editor-shared-styles/utils';
import { getAnonymousAvatarWithStyling } from '@atlaskit/anonymous-assets/get-anonymous-asset';

import { getParticipantColors } from '../presenceUtils.ts';

// IMPORTANT ensure any changes here are also updated in fabric-providers/fetchAnonymousAsset
// while this is more suitable to be in a common package (like @atlaskit/editor-common), importing the anonymous-assets package causes
// syntax errors on e2e builds https://atlassian.slack.com/archives/CL6HC337Z/p1750468928674579
export const useAnonymousAsset = () => {
	const fetchAnonymousAsset = useCallback((presenceId: string | undefined) => {
		const hashCode = presenceId ? getHashCode(presenceId) : 0;

		const primaryIndex = hashCode;

		const svgBackgroundColor = getParticipantColors(presenceId).svgBackgroundColor;

		return getAnonymousAvatarWithStyling({
			styleProperties: {
				'background-color': svgBackgroundColor,
			},
			index: primaryIndex,
		});
	}, []);

	return {
		fetchAnonymousAsset,
	};
};
